// Импорт функции динамического разрешения URL API
import { resolveApiUrls } from '@/utils/resolveApiUrls'

// Тестовые initData для Telegram WebApp в dev-режиме
export const INIT_DATA_DEV = import.meta.env.VITE_APP_INIT_DATA_DEV as string

// Динамически разрешённые URL gRPC и REST серверов
const { grpcUrl, restUrl } = resolveApiUrls()

// Базовый URL gRPC-сервера (например, https://grpc.dev.example.com)
export const API_BASE_URL = grpcUrl
// Базовый URL REST-сервера (например, https://rest.dev.example.com)
export const REST_BASE_URL = restUrl

// Таймзона бэкенда для корректного отображения дат
export const TIME_ZONE = import.meta.env.VITE_APP_TIMEZONE ?? '+00:00'
// Номер сборки приложения
export const VITE_APP_BUILD = import.meta.env.VITE_APP_BUILD
// Реэкспорт единого флага dev/prod — определён в @/modules/constants/buildMode
export { IS_DEV_BUILD } from '@/modules/constants/buildMode'
